"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _utils = require('shared/store/utils');
var _helpers = require('shared/actions/helpers');



const getOrgBrandingActions = _utils.createAsyncActions('GetOrgBranding')
const saveOrgBrandingActions = _utils.createAsyncActions('SaveOrgBranding')

// Admins of verified orgs with the BRANDING bit; the server refuses others.
const getOrgBranding = (req) =>
  _helpers.wsCommand('GetOrgBranding', getOrgBrandingActions, req, null)

const saveOrgBranding = (req) =>
  _helpers.wsCommand('SaveOrgBranding', saveOrgBrandingActions, req, null)

exports. default = {
  getOrgBranding,
  saveOrgBranding,
}
